import React, {useEffect, useState} from 'react';
import {Button, Icon, Modal, Select} from "react-materialize";
import styled from "styled-components";
import AuthUser from "./AuthUser.react";
import TBInput from "../../Commons/Input.react";
import useFetch from "../../../Utilities/API/useFetch.react";

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .header-title {
    color: #515151;
    font-size: 3rem;
    font-weight: 400;
    letter-spacing: 1px;
    padding-left: 1rem;
    padding-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    
    .create-button {
      text-align: right;
      padding-bottom: 1rem;
      
      .btn {
        background-color: #3388BD;
        display: flex;
        
        i {
          font-size: 1.5rem;
          font-weight: bold;
          margin-left: .5rem;
        }
      }
    }
  }
  

`

const StyledUsers = styled.div`
  .title {
    font-size: 2.2rem;
    line-height: 102%;
    font-weight: 300;
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
  
  .auth-users-table {
    padding-top: 1.5rem;
  }
`

const StyledHeader = styled.div`
  color: black;
  background-color: #FFFFFF;
  border-bottom: 2px solid #E2E5E8;
  padding: 3rem 4rem;
  display: flex;
  justify-content: space-evenly;

  th {
    font-size: 2rem;
    width: 100%;
    text-align: left;
  }
  
  th:nth-last-child(2) {
    width: ${props => props.showActions === true ? '50%' : '100%'};
  }
  
  th:last-child {
    width: ${props => props.showActions === true ? '10%' : '54%'};
    ${props => props.showActions && 'text-align: right'};
  }
`

const AuthorizedUsers = ({users, authRoles, showActions, loading}) => {
  const [fetchUrl] = useFetch();
  const [authUsers, setAuthUsers] = useState([])
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setAuthUsers(users);
  }, [users])

  const handleClick = (action, ...rest) => {
    console.log('add user')
    setOpen(!open);
  }

  const handleChange = (e) => {
    if (e.target.name === 'name') {
      setName(e.target.value);
    } else {
      setEmail(e.target.value);
    }
  }

  const handleSelect = (target) => {
    let newRoles = target.value.length > 1 ? target.value.split(', ') : [target.value];
    setRoles(newRoles);
  }

  const handleSubmit = async () => {
    let userRoles = []
    await authRoles.forEach((role) => {
      if (roles.includes(role.name)) {
        userRoles.push(role.id);
      }
    })

    let user = {name: name, email: email, roles: userRoles};
    let userResponse = await fetchUrl('createAuthUser', user);
    let updatedUsers = [...authUsers, userResponse]
    setAuthUsers(updatedUsers);
  }

  return (
    <StyledCard>
      <Modal
        header={'Add User'}
        open={open}
        preventScrolling={true}
        options={{
          onCloseEnd: () => { setOpen(false)}
        }}
        actions={[
          <Button onClick={handleSubmit} flat modal={'close'} node={'button'} waves={'green'}>Add User</Button>
        ]}
      >
        <div>
          <TBInput name={'name'} handleChange={handleChange} value={name} label={'Name'} />
          <TBInput name={'email'} handleChange={handleChange} value={email} label={'Email'} />
          {/*//TODO: Make this select a component for reusability */}
          <Select
            id={'user-role-selection'}
            multiple
            name={'select'}
            label={'Roles'}
            options={{
              classes: '',
              dropdownOptions: {
                alignment: 'left',
                autoTrigger: true,
                closeOnClick: true,
                constrainWidth: true,
                coverTrigger: true,
                hover: false,
                inDuration: 150,
                onCloseEnd: handleSelect,
                onCloseStart: null,
                onOpenEnd: null,
                onOpenStart: null,
                outDuration: 250
              }
            }}
            value={roles}
          >
            {
              authRoles && authRoles?.map((role) => {
                return <option value={role.name}>{role.name}</option>
              })
            }
          </Select>

        </div>
      </Modal>
        <div className={'header-title'}>
          <h2>User Management</h2>
          {
            showActions &&
            <div className={'create-button'}>
              <Button onClick={() => handleClick('ADD_USER')}>
                Add User
                <Icon>group_add</Icon>
              </Button>
            </div>
          }
        </div>
        <StyledUsers>
          <div className={'user-details'}>
            <div>
              <table>
                <StyledHeader showActions={showActions}>
                  <th data-field="name">
                    Name
                  </th>
                  <th data-field="email">
                    Email
                  </th>
                  <th data-field="roles">
                    Roles
                  </th>
                  {
                    showActions &&
                    <th data-field={'actions'}>
                      Actions
                    </th>
                  }
                </StyledHeader>
                <tbody>
                {
                    authUsers?.map((user, index) => {
                      return <AuthUser
                                index={index}
                                authRoles={authRoles}
                                handleAction={handleClick}
                                user={user}
                                showActions={showActions}
                      />
                    })
                }
                </tbody>
              </table>
            </div>
          </div>
        </StyledUsers>
    </StyledCard>
  )
}

export default AuthorizedUsers;